import OrganizationService from "@/api/services/organization";

const initialState = {
  current: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    current: (state) => state.current,
    invoiceLevel: (state) => state.current?.invoiceLevel,
    isStoreInvoiceLevel: (state) => state.current?.invoiceLevel === "store",
    isBillingEntityInvoiceLevel: (state) => state.current?.invoiceLevel === "billing_entity",
    isOrganizationInvoiceLevel: (state) => state.current?.invoiceLevel === "organization",
    regions: (state) => state.current?.regions || [],
  },
  mutations: {
    setCurrent(state, organization) {
      state.current = organization;
    },
  },
  actions: {
    async fetch({ commit, rootState }, { includes = [] } = {}) {
      const organizationId = rootState.auth.currentUser?.organization?.id;
      if (!organizationId) return;
      const organization = await OrganizationService.getOrganization(organizationId, includes);
      commit("setCurrent", organization);
      return organization;
    },

    async update(_, { id, data }) {
      return OrganizationService.updateOrganization(id, data);
    },
  },
};
